import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";
import { toast } from "react-toastify";
import { errorMessageToast } from "../helper";
import { param } from "jquery";

// Job
export const userBasedJobSearch = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/search/v3`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const kmCalculation = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/km-calculation`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const jobById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/${id}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateJob = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/job`,
    data
  );
  return response.data;
};

// Job Flags

export const jobFlagsByJobId = async (id, type) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/flag/byjob/${id}/bytype/${type}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const jobFlagsByFunction = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/flag/details-by-job`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const flagLogHistory = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/flag/flag-history`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const vehicleAssignmentHistory = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/veh-assign/history`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const shipmentStatus = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/shipment-status`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const shipmentStatusRemainingData = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/shipment-status/remaining-data`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const createJobFlags = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/job/flag`,
    data
  );
  return response.data;
};

export const updateJobFlags = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/job/flag`,
    data
  );
  return response.data;
};

export const getNonDisputeFlagCount = async (jobId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/flag/non-dispute-count/${jobId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
    return -1;
  }
};

// Job Other

export const jobOtherByJobId = async (id, type) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/other/byjob/${id}/bytype/${type}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const createJobOther = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/job/other`,
    data
  );
  return response.data;
};

export const updateJobOther = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/job/other`,
    data
  );
  return response.data;
};

// Job Status
export const getJobCurrentStatus = async (jobId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/current-status/${jobId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const jobStatusHistory = async ({ requestId, jobId }) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/user-type-status`,
      {
        lRequest: requestId,
        lJob: jobId,
      }
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getTimeRemovalLog = async (jobId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/time-removal-log/job/${jobId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateJobStatus = async ({
  sUser,
  lRequest,
  sCode = null,
  lStatus,
  lJob,
  iType = 1,
  iFromApprove = 0,
}) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/job/update-status`,
    {
      sUser,
      lRequest,
      sCode,
      lStatus,
      lJob,
      iType,
      iFromApprove,
    }
  );
  return response.data;
};

// Job Status Amend

export const updatableStatus = async ({ jobId, currentStatus }) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/updatable-status/${jobId}/${currentStatus}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
    toast.error("Error occurred", { autoClose: 5000, containerId: "Modal" });
    return {
      timeChangeRequestedId: -3,
      updatableStatusDropdown: [],
      isStatusUpdateEnabled: false,
    };
  }
};

export const timeAmendSelection = async ({ jobId }) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/time-amend-selection/${jobId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
    toast.error("Error occurred", { autoClose: 5000, containerId: "Modal" });
    return {
      timeAmendSelectionDropdown: [],
      timeAmendSelectionDropdownMap: {},
    };
  }
};

export const statusAmend = async (data) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/status-amend`,
      data
    );
    return response.data;
  } catch (e) {
    toast.error("Error occurred", { autoClose: 5000, containerId: "Modal" });
    console.error(e);
    return { statusId: -2, statusName: "" };
  }
};

// Vehicle Assignment

export const vehicleAssignmentSearch = async ({
  searchText = null,
  lTransporter = null,
  lDriver = null,
  iSearchType = null,
  lVehicleType = null,
  lCommit = null,
  cbm = null,
  fullObject = false,
  status = null,
}) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/vehicleassignment/search`,
      {
        lTransporter,
        sVehicle: searchText,
        lDriver,
        iSearchType,
        lVehicleType,
        lCommit,
        cbm,
        status,
      }
    );
    const data = response.data;

    return fullObject
      ? data.map((item) => ({
          ...item,
          key: item.vehicleAssignmentDropdown.id,
          value: item.vehicleAssignmentDropdown.value,
          title: item.vehicleAssignmentDropdown.text,
        }))
      : data.map((item) => ({
          key: item.vehicleAssignmentDropdown.id,
          value: item.vehicleAssignmentDropdown.value,
          title: item.vehicleAssignmentDropdown.text,
        }));
  } catch (e) {
    console.error(e);
  }
};

export const vehicleAssignmentByJobId = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/vehicleassignment/byjob/${id}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const asignJobVehicle = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/job/vehicleassignment`,
    data
  );
  return response.data;
};

export const removeAssignedVehicle = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/job/vehicleassignment/delete`,
    data
  );
  return response.data;
};

export const getVehicleAllocations = async (vehId) => {
  const response = await gatewayInstance.get(
    `${SERVICE_ENDPOINT.TRANSPORT}/job/vehicleallocations/byvehid/${vehId}`
  );
  return response.data;
};
// Time Update

export const timeUpdateByJobId = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/timeupdate/byjob/${id}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateLocationTime = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/timeupdate`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

//Status Update

export const jobStatusUpdate = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/job/status-update`,
    data
  );
  return response.data;
};

export const jobConfirmation = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/confirm-job`,
      data
    );
    return response.data;
  } catch (error) {
    errorMessageToast(error);
    throw error;
  }
};

// KM Method

export const kmMethodsByJob = async (jobId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/km-methods/${jobId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const selectKmMethod = async (data) => {
  try {
    await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/km-methods/select`,
      data
    );
  } catch (e) {
    console.error(e);
  }
};

//getjob with type and flagtype

export const jobFlagsByJobIdAndFlagId = async (id, type, flagTypes) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/flag/by-flag-type`,
      {
        jobId: id,
        type: type,
        flagTypes: flagTypes,
      }
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const checkDemmurrage = async (jobId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/demurrage-availability/${jobId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getConfirmDetails = async (jobId, stakeholder) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/reason-availability/${jobId}/${stakeholder}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const maxCbmByJobId = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehicletype/max-cbm/${id}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getNegotiationCharge = async (type) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/user-supplier-negotiation/negotiation/type`,
      {
        params: {
          type: type,
        },
      }
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const resolveDisputeApi = async (data) => {
  try {
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/job/resolve-dispute`,
        data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};


export const retryKmActual = async (jobIds) => {
  try {
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/retry-km/actual`,
        jobIds
    );
    return response.data;
  } catch (e) {
    console.error("Error retrying Actual KM:", e);
    errorMessageToast(e);
  }
};


export const retryChargeableKM = async (jobIds) => {
  try {
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/retry-km/chargeable`,
        jobIds
    );
    return response.data;
  } catch (e) {
    console.error("Error retrying Chargeable KM:", e);
    errorMessageToast(e);
  }
};


export const retryKmPlanned = async (jobIds) => {
  try {
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/retry-km/planned`,
        jobIds
    );
    return response.data;
  } catch (e) {
    console.error("Error retrying Planned KM:", e);
    errorMessageToast(e);
  }
};

export const jobFreezeAndUnFreeze = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/job/freeze`,
    data
  );
  return response;
};


export const enableFoc = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/job/foc`,
    data
  );
  return response;
};

export const getLiveTrackLink = async(jobId)=>{
  try{
  const response = await gatewayInstance.get(
    `${SERVICE_ENDPOINT.TRANSPORT}/job/live-track-link/${jobId}`
  );
  return response.data;
}
catch(e){
  console.log(e);
}
}